import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $addNotificationPadding?: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    ${({ $addNotificationPadding }) =>
        $addNotificationPadding &&
        css`
            padding: 0 0 136px 0;
        `}
`;

interface HeadingCellWrapperProps {
    $isCentered?: boolean;
    $isRightAligned?: boolean;
    $addPadding?: boolean;
}

export const HeadingCellWrapper = styled.div<HeadingCellWrapperProps>`
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
    justify-content: ${({ $isCentered, $isRightAligned }) =>
        $isCentered ? 'center' : $isRightAligned ? 'flex-end' : 'flex-start'};

    ${({ $addPadding }) =>
        $addPadding &&
        css`
            padding: 0 16px;
        `}
`;

interface HeadingTitleProps {
    $disableButton?: boolean;
    $isActive?: boolean;
    $isDesc?: boolean;
}

export const HeadingTitle = styled.div<HeadingTitleProps>`
    font-weight: 700;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: -0.02em;
    text-transform: uppercase;
    color: #ffffff;
    opacity: 0.4;
    cursor: default;
    position: relative;
    user-select: none;

    white-space: nowrap;

    svg {
        position: absolute;
        opacity: 0.6;
        width: 13px;
        right: -15px;
        top: 0;
    }

    :before {
        content: '';
        position: absolute;
        right: -15px;
        top: 0;
        width: 5px;
        height: 10px;
        opacity: 0;

        border-color: transparent;
        border-top-color: #ffffff;
        border-style: solid;

        border-width: 0 0.4em 0.6em;
        border-top-color: transparent;
        border-bottom-color: #ffffff;
    }

    ${({ $disableButton }) =>
        !$disableButton &&
        css`
            &:hover {
                opacity: 1;
            }
        `}
    ${({ $isActive }) =>
        $isActive &&
        css`
            opacity: 1;
            :before {
                opacity: 1;
            }
        `}
    ${({ $isDesc }) =>
        $isDesc &&
        css`
            :before {
                transform: rotate(180deg) translateY(-3px);
            }
        `}
`;

export const DiscoverBarWrapper = styled.div<{ $isWideDesktop?: boolean }>`
    z-index: 2;
    width: 100%;
    gap: 20px;

    position: sticky;
    top: 47px;

    display: grid;

    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
        'search search search'
        '. fresh-toggle .';

    padding: 15px 0 30px 0;

    background: linear-gradient(to bottom, rgba(10, 7, 26, 1) 0%, rgba(10, 7, 26, 1) 75%, rgba(10, 7, 26, 0) 100%);

    ${({ $isWideDesktop }) =>
        $isWideDesktop &&
        css`
            display: flex;
            flex-direction: row;
            gap: 20px;
            justify-content: space-between;
            align-items: center;
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        top: 100px;
        padding: 20px 0 40px 0;
        margin-top: -20px;
    }
`;

export const EmptyWrapper = styled(motion.div)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    button {
        margin: 30px 0 0 0 !important;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: 45px auto auto;
        button {
            margin: 40px 0 0 0 !important;
        }
    }
`;

export const EmptyImages = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 7px;
    img {
        width: 105px;
        height: 105px;
        &:last-of-type {
            width: 70px;
            height: 70px;
        }
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 15px;

        img {
            width: 137px;
            height: 137px;
            &:last-of-type {
                width: 96px;
                height: 96px;
            }
        }
    }
`;

export const EmptyHeading = styled.div`
    text-align: center;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 105%; /* 33.6px */
    letter-spacing: -0.64px;
    margin-bottom: 10px;
    margin-top: -10px;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 32px;
        margin-bottom: 14px;
        margin-top: 0;
    }
`;

export const EmptySubHeading = styled.div`
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 105%;
    letter-spacing: -0.36px;
    max-width: 540px;
    span {
        white-space: nowrap;
        font-weight: 700;
        color: rgba(255, 255, 255, 1);
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 18px;
    }
`;

export const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 10px;
    padding-bottom: 100px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
        gap: 15px;
    }
`;

export const MobileButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    position: fixed;
    top: 78px;
    left: 0;
    z-index: 2;

    width: 100%;

    padding: 20px 20px 20px 20px;

    background: linear-gradient(to bottom, rgba(10, 7, 26, 1) 0%, rgba(10, 7, 26, 1) 75%, rgba(10, 7, 26, 0) 100%);
`;
